var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z",
    fill: "#CACACA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4498_14800",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4498_14800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 19.98C14.7613 21.0252 12.6967 21.1333 10.5 21.1333C8.30331 21.1333 6.503 21.2243 5 19.9802V17.6532C5 16.1364 6.23321 14.9032 7.75 14.9032C8.22696 14.9032 8.93165 15.393 10.5 15.393C12.0727 15.393 12.7688 14.9032 13.25 14.9032C14.7668 14.9032 16 16.1364 16 17.6532V19.98ZM10.5 6C8.41172 6 6.71875 7.69297 6.71875 9.78126C6.71875 11.8695 8.41172 13.5625 10.5 13.5625C12.5883 13.5625 14.2813 11.8695 14.2813 9.78126C14.2813 7.69297 12.5883 6 10.5 6Z",
    fill: "#949494"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUser);
export default __webpack_public_path__ + "static/media/no-user.cc8e3986e997f56ec5c99479c1fef5d9.svg";
export { ForwardRef as ReactComponent };